import { render, staticRenderFns } from "./QuickRepliesSection.vue?vue&type=template&id=3d500ca9&scoped=true&"
import script from "./QuickRepliesSection.vue?vue&type=script&lang=js&"
export * from "./QuickRepliesSection.vue?vue&type=script&lang=js&"
import style0 from "./QuickRepliesSection.vue?vue&type=style&index=0&id=3d500ca9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d500ca9",
  null
  
)

export default component.exports